import { SunMedium } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, SplitFeature } from "@/components/blocks";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { COMPANY, IMAGES } from "@/data/site";

export default function Solar() {
  return (
    <>
      <Seo
        title="Solar Energy Solutions — Coming Soon | CTS"
        siteName={COMPANY.brand}
        description="CTS is preparing to expand into solar energy solutions for homes and businesses in Mallappally. Register your interest."
      />
      <PageHero
        eyebrow="SOLAR ENERGY SOLUTIONS"
        title="Solar Energy Solutions"
        intro="CTS is preparing to expand into solar energy solutions for homes and businesses, helping customers explore practical solar options for their energy needs."
        crumbs={[{ label: "Services", to: "/services" }, { label: "Solar Energy Solutions" }]}
        badge="COMING SOON"
      />
      <section className="section-pad bg-white">
        <div className="container-site">
          <SplitFeature
            eyebrow="A FUTURE CTS SERVICE"
            title="Practical Solar, Being Prepared Properly"
            paragraphs={[
              "Solar energy solutions are not currently being offered by CTS. We are preparing this service carefully, and we will announce details once they are confirmed.",
              "Interested in solar for your home or business? Register your interest and we'll reach out when this service launches.",
            ]}
            image={IMAGES.solar}
            alt="Solar panels"
            testId="solar-feature"
          />
        </div>
      </section>
      <section id="register" className="section-pad bg-cts-soft">
        <div className="container-site">
          <div className="max-w-xl mx-auto rounded-xl border border-cts-line bg-white shadow-[0_24px_60px_-40px_rgba(23,27,30,0.35)] p-6 md:p-9" data-testid="solar-form-card">
            <Reveal>
              <div className="flex items-center gap-3 mb-2">
                <SunMedium size={22} strokeWidth={1.75} className="text-cts-red" />
                <p className="eyebrow">REGISTER YOUR INTEREST</p>
              </div>
              <h2 className="h3-display mb-2">Hear About Solar When It Launches</h2>
              <p className="text-cts-charcoal text-[15px] mb-6">
                No pricing or packages are published yet — registering simply lets us contact you when
                CTS solar energy solutions become available.
              </p>
              <LeadForm
                formType="solar"
                requirement="Solar Energy Solutions — Coming Soon"
                fields={["name", "phone", "location", "message"]}
                customFields={[
                  { name: "property_type", label: "Property Type (optional)", type: "select", options: ["Home", "Business", "Institution"] },
                ]}
                submitLabel="REGISTER YOUR INTEREST"
                trackEvent="solar_interest_submitted"
                sourceCta="Solar interest form"
                testIdPrefix="solar-form"
              />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
